import React, { useMemo } from 'react';
import PropTypes, { any } from 'prop-types';

import { hasPositionWon, shouldDisplayWinnerAndScoreData } from '../../../../utils/matchScorePrintPage';

import styles from './matchSheetScoreData.scss';

const MatchSheetScoreData = (props) => {
    const { match } = props;
    const shouldDisplayWinnerScoreData = shouldDisplayWinnerAndScoreData(match);
    const sets = Array(4).fill(null).map((_, index) => index);

    const scoresArray = useMemo(() => {
        if (shouldDisplayWinnerScoreData) {
            const resultSets = Array(3).fill(null).map((_, index) => index + 1);
            return resultSets.reduce((acc, setNumber) => {
                const winnerSet = match.result[`winnerSet${setNumber}`];
                const loserSet = match.result[`loserSet${setNumber}`];
                const tiebreakerSet = match.result[`tiebreakerSet${setNumber}`];
                if (winnerSet || loserSet) {
                    acc.push({
                        winner: winnerSet,
                        loser: loserSet,
                        tiebreak: tiebreakerSet >= 0 ? tiebreakerSet : null,
                    });
                }
                return acc;
            }, []);
        }

        return [];
    }, [match]);

    const shouldInvert = useMemo(() => {
        if (match?.result) {
            return hasPositionWon(match, 'positionTwo');
        }

        return false;
    }, [match]);

    return (
        <div className={`${styles.matchSheetScoreData} ${shouldInvert ? styles.invert : ''}`}>
            {!shouldDisplayWinnerScoreData && (
                <div className={styles.description}>
                    IF ABOVE WINS MATCH,
                    <br />
                    <br />
                    ALL SCORES AND INITIAL
                </div>
            )}
            <div className={styles.setsData}>
                {sets.map((set) => {
                    const currentSetScore = set < scoresArray.length ? scoresArray[set] : null;
                    return (
                        <div
                            key={`set-${set}`}
                            className={styles.set}
                        >
                            {currentSetScore && (
                                <div className={styles.score}>
                                    <span className={styles.winner}>{currentSetScore.winner}</span> - {currentSetScore.loser}{currentSetScore.tiebreak && `(${currentSetScore.tiebreak})`}
                                </div>
                            )}
                            <div className={styles.divider} />
                            {currentSetScore && (
                                <div className={`${styles.score} ${styles.hide}`}>
                                    <span className={styles.winner}>{currentSetScore.winner}</span> - {currentSetScore.loser}{currentSetScore.tiebreak && `(${currentSetScore.tiebreak})`}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            {!shouldDisplayWinnerScoreData && (
                <div className={`${styles.description} ${styles.invert}`}>
                    IF BELOW WINS MATCH,
                    <br />
                    <br />
                    ALL SCORES AND INITIAL
                </div>
            )}
        </div>
    );
};

MatchSheetScoreData.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
};

MatchSheetScoreData.defaultProps = {};

export default MatchSheetScoreData;
